import { useQuery } from "react-query";
import getPublicApplications from "../APIs/marketplace/getPublicApplications";
import getInstalledApplications from "../APIs/marketplace/getInstalledApplications";

const useMarketplace = ({ categoryId } = {}) => {
  const { data: applications } = useQuery(
    ["get-apps", { categoryId, robotId: "f3ff7986-b365-43ef-aaa3-b5b3f21b4275" }],
    getPublicApplications,
    { categoryId },
  );

  return { applications };
};

const useInstalledApplications = ({ robotId } = {}) => {
  const { data: applications } = useQuery(["get-apps", { robotId }], getInstalledApplications, {
    robotId,
  });

  console.log("applications!", applications);
  return { applications };
};

export { useMarketplace, useInstalledApplications };
